import {
  Text,
  Primary14ExtendedRegular,
  GreyGrey100,
  GreyGrey80,
  PrimaryHeader32Regular,
  Button,
  Link,
  AuthUI
} from '@sequencehq/core-components'

export const PkceMismatchPage = () => {
  return (
    <AuthUI.Section gap="16px">
      <Text
        {...PrimaryHeader32Regular}
        textAlign="left"
        color={GreyGrey100}
        marginBottom="0px"
      >
        There seems to be a mix-up with your magic link
      </Text>
      <Text {...Primary14ExtendedRegular} color={GreyGrey80}>
        If you've requested more than one link, only the latest one will work.
        Please check your email for the most recent magic link we sent you or
        try again.
      </Text>
      <Link
        to="/login"
        _hover={{
          textDecoration: 'none'
        }}
      >
        <Button
          variant="primary"
          fullWidth
          size="40px"
          style={{ fontSize: '14px', borderRadius: '8px' }}
        >
          Try again
        </Button>
      </Link>
    </AuthUI.Section>
  )
}

export default PkceMismatchPage
